import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "item-center" }
const _hoisted_2 = {
  key: 0,
  class: "avatar-circle mright-04"
}
const _hoisted_3 = {
  key: 1,
  class: "font-size-16 font-bold-700 ellipsis"
}

import { ItemTag } from '@/models/share.model';


export default /*@__PURE__*/_defineComponent({
  __name: 'esDoctorItem',
  props: {
    item: {},
    initial: {}
  },
  setup(__props: any) {




return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.initial)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_ctx.initial), 1))
      : _createCommentVNode("", true),
    (_ctx.item)
      ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(_ctx.item.label), 1))
      : _createCommentVNode("", true)
  ]))
}
}

})